import {
  GET_DSP_USER_LIST,
  GET_TARIFF,
  GET_UNUSED_VOUCHER,
  GET_VOUCHER_MANAGEMENT,
  SAVE_INVOICE,
  GET_VOUCHER_SEARCH,
  CHECK_VOUCHER_INVOICE,
  GENERATE_DELIVERY_NOTES,
  GENERATE_INVOICE,
  CLEAR_DELIVERY_NOTES_PREVIEW
} from "../../admin-constants";

const initialState = {
  dspUserList: [],
  planData: [],
  voucherData:[],
  voucherManageData: [],
  invoiceSaveData: [],
  voucherSearchData:[],
  voucherStatusData:[],
  deliveryNotesData:[],
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_DSP_USER_LIST: {
      return {
        ...state,
        dspUserList: payload,
      };
    }
    case GET_TARIFF: {
      return {
        ...state,
        planData: payload,
      };
    }
    case GET_UNUSED_VOUCHER: {
      return {
        ...state,
        voucherData: payload,
      };
    }
    case GET_VOUCHER_MANAGEMENT: {
      return {
        ...state,
        voucherManageData: payload,
      };
    }

    case SAVE_INVOICE: {
      return {
        ...state,
        invoiceSaveData: payload,
      };
    }

    case GET_VOUCHER_SEARCH: {
      return {
        ...state,
        voucherSearchData: payload,
      };
    }

        case CHECK_VOUCHER_INVOICE: {
      return {
        ...state,
        voucherStatusData: payload,
      };
    }

            case GENERATE_DELIVERY_NOTES: {
      return {
        ...state,
        deliveryNotesData: payload,
      };
    }

    case CLEAR_DELIVERY_NOTES_PREVIEW:
  return {
    ...state,
    deliveryNotesData: null,
  };



    default:
      return state;
  }
};

export default reducer;
